export default () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.71402 3.33301C11.7189 3.33301 14.4359 4.98319 15.9819 7.74676C16.0694 7.90259 16.0694 8.09725 15.9819 8.25258C14.4359 11.0167 11.7189 12.6663 8.71402 12.6663C5.70916 12.6663 2.99214 11.0162 1.44617 8.25258C1.35909 8.09725 1.35909 7.9021 1.44617 7.74676C2.99214 4.9827 5.70916 3.33301 8.71402 3.33301ZM14.4564 7.81048C13.1089 5.82009 11.0106 4.66634 8.71402 4.66634C6.34565 4.66634 4.18855 5.89285 2.84749 7.9997C4.18812 10.106 6.34562 11.333 8.71402 11.333C11.0099 11.333 13.1072 10.1805 14.4562 8.1887L14.5805 7.99953L14.4564 7.81048ZM8.71419 5.99967C9.81719 5.99967 10.7142 6.89667 10.7142 7.99967C10.7142 9.10267 9.81719 9.99967 8.71419 9.99967C7.61119 9.99967 6.71419 9.10267 6.71419 7.99967C6.71419 6.89667 7.61119 5.99967 8.71419 5.99967ZM8.71419 7.33301C8.34757 7.33301 8.04753 7.63305 8.04753 7.99967C8.04753 8.36629 8.34757 8.66634 8.71419 8.66634C9.08081 8.66634 9.38086 8.36629 9.38086 7.99967C9.38086 7.63305 9.08081 7.33301 8.71419 7.33301Z"
      fill="currentColor"
    />
  </svg>
);
